import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const authApi = {
  login: async (credentials) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.AUTH}/login`, credentials);
      return response.data;
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  },

  logout: async () => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.AUTH}/logout`);
      return response.data;
    } catch (error) {
      console.error('Error during logout:', error);
      throw error;
    }
  },

  getUser: async () => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.AUTH}/user`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  },

  getAuthUserPermissions: async () => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.PERMISSIONS}/user`);
      return response.data;
    } catch (error) {
      console.error('Error fetching authenticated user permissions:', error);
      throw error;
    }
  },

  resendVerificationEmail: async () => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.AUTH}/email/resend`);
      return response.data;
    } catch (error) {
      console.error('Error resending verification email:', error);
      throw error;
    }
  },
};

export default authApi;